<template>
  <div class="tw-inline-block tw-w-full tw-cursor-pointer tw-transition tw-group tw-relative tw-rounded tw-overflow-hidden tw-text-white">
    <!-- Artwork -->
    <div class="tw-relative tw-block tw-aspect-w-1 tw-aspect-h-1 tw-overflow-hidden">
      <slot name="artwork"></slot>
    </div>

    <!-- Overlay -->
    <div @click="$emit('click')" class="tw-absolute tw-z-10 tw-inset-0 tw-transition group-hover:tw-bg-infinity-highlight-overlay" :class="{'tw-bg-infinity-highlight-overlay': active}">
      <div class="vc-shadows-top tw-opacity-30 tw-absolute tw-inset-0"></div>
      <div class="vc-shadows-bottom tw-opacity-30 tw-absolute tw-inset-0"></div>
      <!-- Header -->
      <div class="tw-absolute tw-m-3 tw-relative tw-z-10">
        <!-- Title  -->
        <div class="tw-truncate hover:tw-underline tw-text-md md:tw-text-lg tw-font-bold">
          <slot name="title"></slot>
        </div>

        <!-- Subtitle  -->
        <div class="tw-font-light tw-text-sm md:tw-text-base">
          <slot name="subtitle"></slot>
        </div>
      </div>

      <!-- Play Button -->
      <div class="tw-absolute tw-inset-0 can-hover:tw-opacity-0 tw-transition tw-flex tw-items-center tw-justify-center group-hover:tw-opacity-100">
        <slot name="playButton"></slot>
      </div>

      <!-- Buy Button -->
      <div class="tw-absolute tw-bottom-0 tw-right-0 tw-p-4">
        <slot name="buyButton"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.vc-shadows-top {
  top: -6px;
  background: linear-gradient(to top, transparent 0%, black 100%);
}
.vc-shadows-bottom {
  bottom: -6px;
  background: linear-gradient(to bottom, transparent 0%, black 100%);
}
</style>
